import { embedFilter } from '../sharedFilters'

const DATASET_KEY = 'security_managment_crisis'

export default {
  key: 'security_managment_crisis',
  label: 'GSMS - Crisis',
  timeColumn: 'security_managment_crisis.created_at',
  permission: { action: 'reporting', subject: 'Widget' },

  tables: {
    security_managment_crisis: ["id", "crisis_id", "impacted_sectors", "building_code", "risk_category", "risk_description", "closure_date", "crisis_level", "critical_vendors", "regulator_communications", "bcm_invoked", "country_cmt_activated", "rto_met", "staff_impact", "customer_impact", "business_impact", "market_impact", "facility_premises_impact", "community_response", "created_by", "created_on", "last_updated_by", "last_updated_on", "executive_summary", "crisis_id_row", "crisis_id_count", "created_at", "updated_at"],
    security_managment_facility: ["id", "facility_id", "csis_building_status", "crs_building_status", "region", "country", "state", "city", "zip", "address", "building_code", "facility_name", "floor_code", "occupied", "has_data_center", "has_child_care", "number_of_floors", "occupied_floors", "owned_or_leased", "vacancy_date", "headcount", "updated_headcount", "primary_facility_type", "source_instance", "created_at", "updated_at"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  csvConfig: {
    withTables: 'security_managment_crisis',
    columns: 'security_managment_facility.building_code,security_managment_facility.facility_name,security_managment_facility.address,security_managment_facility.city,security_managment_facility.state,security_managment_facility.country,security_managment_facility.primary_facility_type,security_managment_facility.csis_building_status',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'security_managment_facility.building_code', label: 'Instalacion' },
    { key: 'security_managment_facility.facility_name', label: 'Nombre instalacion' },
    { key: 'security_managment_facility.address', label: 'Direccion' },
    { key: 'security_managment_facility.city', label: 'Ciudad' },
    { key: 'security_managment_facility.state', label: 'Estado' },
    { key: 'security_managment_facility.country', label: 'Pais' },
    { key: 'security_managment_crisis.country_cmt_activated', label: 'CMT activado' },
    { key: 'security_managment_crisis.risk_description', label: 'Descripcion' },
    { key: 'security_managment_crisis.risk_category', label: 'Categoria' },
    { key: 'security_managment_crisis.crisis_id', label: 'Referencia' },
    { key: 'security_managment_crisis.community_response', label: 'Respuesta comunidad' },
    { key: 'security_managment_crisis.crisis_level', label: 'Nivel' },
    { key: 'security_managment_crisis.created_at', label: 'Fecha', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    embedFilter(DATASET_KEY, 'security_managment_facility.building_code', 'Instalacion', 'installation'),
    embedFilter(DATASET_KEY, 'security_managment_facility.facility_name', 'Nombre instalacion', 'facility_name'),
    embedFilter(DATASET_KEY, 'security_managment_facility.city', 'Ciudad', 'city'),
    embedFilter(DATASET_KEY, 'security_managment_facility.state', 'Estado', 'state'),
    embedFilter(DATASET_KEY, 'security_managment_facility.country', 'Pais', 'country'),
    embedFilter(DATASET_KEY, 'security_managment_crisis.country_cmt_activated', 'CMT activado', 'status'),
    embedFilter(DATASET_KEY, 'security_managment_crisis.risk_category', 'Categoria', 'group'),
    embedFilter(DATASET_KEY, 'security_managment_crisis.crisis_id', 'Referencia', 'reference'),
    embedFilter(DATASET_KEY, 'security_managment_crisis.community_response', 'Respuesta comunidad', 'type'),
    embedFilter(DATASET_KEY, 'security_managment_crisis.crisis_level', 'Nivel', 'level'),
  ],

    dateGrouping: {
    column: 'security_managment_crisis.created_at',
    presets: [
      { value: '1d', label: 'Dia' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Anio' },
    ],
  },
}
